import { render } from "./MassMediaCard.vue?vue&type=template&id=dd9f724a"
import script from "./MassMediaCard.vue?vue&type=script&lang=js"
export * from "./MassMediaCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__